module.exports = __webpack_public_path__ + "img/account-management.063534ef.png";